import {
  Alert,
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import clsx from "clsx";
import IconText from "components/IconText";
import {
  GetTitleSafely,
  StatusType,
  borderColors,
  truncateWithEllipses,
} from "utils/helper";
import { Send } from "@mui/icons-material";

import { ReactComponent as InfoCircle } from "assets/Svgs/CheckCircle.svg";

import { ReactComponent as HistorySmallSvg } from "assets/Svgs/HistorySmall.svg";

import { ReactComponent as TerminSvg } from "assets/Svgs/terminSvg.svg";
import { ReactComponent as CheckSvg } from "assets/Svgs/checkSvg.svg";
import { ReactComponent as RotationSvg } from "assets/Svgs/RotationSvg.svg";
import { ReactComponent as RoundedEditSvg } from "assets/Svgs/RoundedEdit.svg";
import { ReactComponent as RoundedDeleteSvg } from "assets/Svgs/RoundedDeleteSvg.svg";
import { ReactComponent as RoundedbackSvg } from "assets/Svgs/RoundedBack.svg";
import { ReactComponent as SendEmail } from "assets/Svgs/EmailSend.svg";
import { ReactComponent as VerticalDivider } from "assets/Svgs/VerticalDivider.svg";
import { ReactComponent as InfoSvg } from "assets/Svgs/InfoSvg.svg";
import TimelapseIcon from "@mui/icons-material/Timelapse";

import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";

import moment from "moment";

import {
  GetNotificationBorderColor,
  NotificationTypeUpdated,
  getProgressStatus,
  getTypeColor,
} from "shared-functions/notification";
import { Link, useLocation, useNavigate } from "react-router-dom";
import i18n from "i18n/i18n";
import { useEffect, useState } from "react";
import TabPanel from "components/TabPanel";
import OverviewTab from "./tabs/OverviewTab";
import { NotificationStatus, NotificationType } from "assets";
import { useBoundStore } from "store/store";
import TypeBadge from "components/TypeBadge";

function NotificationDetailPage(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  const location = useLocation();
  const navigatee = useNavigate();

  const params = new URLSearchParams(location.search);
  let nodeid: any = params.get("nodeid");

  let notification = location?.state;
  let nodeId = location?.state?.nodeid
    ? location?.state?.nodeid
    : decodeURIComponent(nodeid);

  const loadNotificationDetails = useBoundStore(
    (state) => state.loadNotificationDetails
  );

  const notificationData = useBoundStore(
    (state: any) =>
      state.notificationDetails[
        notification?.nodeid ? notification?.nodeid : nodeId
      ]
  );

  const deleteNotification = useBoundStore((state) => state.deleteNotification);
  const shareNotification = useBoundStore((state) => state.shareNotification);

  const isLoggedIn = useBoundStore((state) => state.isLoggedIn);

  useEffect(() => {
    loadNotificationDetails(
      notification?.nodeid ? notification?.nodeid : nodeId,
      lang
    );
  }, [notification, nodeId]);

  const [navigate, setNavigate] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [alertText, setAlertText] = useState("");
  const [alertType, setAlertType] = useState("error");

  const handleClose = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMore = () => {
    setAnchorEl(null);
  };

  const [isShare, setIsShare] = useState(false);
  const [email, setEmail] = useState("service@mesutronic.de");

  const handleShareOpen = () => {
    setIsShare(true);
  };

  const handleShareClose = () => {
    setIsShare(false);
  };

  const handleShareInputChange = (event: any) => {
    setEmail(event.target.value);
  };

  const handleShareSubmit = () => {
    if (email.length === 0 || !email.includes("@") || !email.includes(".")) {
      setAlertText(i18n(lang)?.email_validation_error);
      setAlertType("error");
      return;
    } else {
      setAlertType("");
      shareNotification(
        email,
        notification?.nodeid ? notification?.nodeid : nodeId
      );
      setIsShare(false);
    }
  };

  useEffect(() => {
    if (!navigate) return;

    const baseMachineDetailUrl = "/machine-detail?nodeid=";

    const navigateToMachineDetail = (nodeId: any, tab: any) => {
      navigatee(
        `${baseMachineDetailUrl}${encodeURIComponent(nodeId)}&tab=${tab}`
      );
    };

    const redirectToTabAfterDelay = (
      nodeId: String,
      tab: any,
      delay = 1000
    ) => {
      setTimeout(() => navigateToMachineDetail(nodeId, tab), delay);
    };

    navigateToMachineDetail(
      notificationData.isnotificationof[0].equipment.nodeid,
      -1
    );
    redirectToTabAfterDelay(
      notificationData.isnotificationof[0].equipment.nodeid,
      0
    );
  }, [navigate]);

  const handleNotificationDelete: any = async () => {
    try {
      const promises = await deleteNotification(
        notificationData?.nodeid,
        notificationData.isnotificationof[0].equipment.nodeid
      );

      if (isLoggedIn === true) {
        const result = await Promise.all(promises);
      }
    } catch (error) {
      console.error(`Error received from axios.post: ${JSON.stringify(error)}`);

      console.error("Error during submission:", error);
    } finally {
      resetFormState();
    }
  };

  const resetFormState = () => {
    setNavigate(true);
  };

  const handleCloseSanckBar = () => {
    setAlertType("");
  };

  return (
    <>
      <div
        className="breadcrumpsWrapper"
        onClick={() => {
          location.state.from === "maintenance_dashboard"
            ? navigatee("/wartungskalender")
            : location.state.from === "maintenance"
            ? navigatee(
                "/machine-detail?nodeid=" +
                  encodeURIComponent(
                    notificationData?.isnotificationof[0]?.equipment?.nodeid
                  ) +
                  "&tab=4"
              )
            : navigatee("/machine-detail", {
                state: {
                  machineNodeId:
                    notificationData?.isnotificationof[0]?.equipment?.nodeid,
                },
              });
        }}
      >
        <div className="backIcon">
          <RoundedbackSvg />
        </div>
        <div className="breadcrumps">{i18n(lang)?.machine_detail}</div>
      </div>
      <section>
        <Paper>
          <Grid
            container
            spacing={3}
            direction="row"
            alignItems="center"
            width={"100%"}
            margin={0}
            className={"ND_HeaderCard"}
            style={{
              borderTopColor: GetNotificationBorderColor(
                notificationData?.type
              ),
              borderTopWidth: 6,
              borderTopStyle: "solid",
              borderRadius: 4,
            }}
          >
            <Grid item xs={8}>
              <div>
                <div className="title">{notificationData?.title}</div>

                <span className={"subTitle"}>
                  {notificationData?.hasOwnProperty("isnotificationof") &&
                  notificationData?.isnotificationof[0].hasOwnProperty(
                    "equipment"
                  ) ? (
                    <>
                      {notificationData?.isnotificationof[0]?.equipment?.name}{" "}
                      {
                        notificationData?.isnotificationof[0].equipment
                          .hasequipmenttype[0].equipmenttype.model
                      }
                      . {notificationData?.name}.
                      {
                        notificationData?.isnotificationof[0].equipment
                          .isequipmentof[0]?.area?.name
                      }
                    </>
                  ) : (
                    ""
                  )}

                  <br />
                </span>
              </div>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ display: "flex", justifyContent: "end" }}
            >
              <div className="preMailButton cp" onClick={handleShareOpen}>
                <div className="icon">
                  <SendEmail />
                </div>
                <div className="text">{i18n(lang)?.share_via_email}</div>
              </div>

              <div style={{ margin: "-3px 0px 5px 24px" }}>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertRoundedIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseMore}
                  className="moreActions"
                >
                  <MenuItem id="1" onClick={handleCloseMore}>
                    <Link
                      to="/edit-notification"
                      state={{
                        notificationData: notificationData,
                        isEditMode: true,
                      }}
                    >
                      <div className="menuItem">
                        <div className="icon">
                          <RoundedEditSvg />
                        </div>
                        <div className="text" style={{ marginLeft: "10px" }}>
                          {" "}
                          {i18n(lang)?.edit}
                        </div>
                      </div>
                    </Link>
                  </MenuItem>
                  <Divider orientation="horizontal" style={{ margin: 0 }} />
                  <MenuItem id="1" onClick={handleNotificationDelete}>
                    <div className="menuItem">
                      <div className="icon">
                        <RoundedDeleteSvg />
                      </div>
                      <div className="text"> {i18n(lang)?.delete}</div>
                    </div>
                  </MenuItem>
                </Menu>
              </div>
            </Grid>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <div>
                <TypeBadge
                  typecode={+notificationData?.type}
                  notification={notificationData}
                />
              </div>
              <div style={{ margin: "0px 10px" }}>
                <VerticalDivider />
              </div>

              <div className="textWithSvg">
                <div className="svg">
                  <InfoSvg />
                </div>
                <div className="text">
                  Status:{" "}
                  {NotificationStatus(Number(notificationData?.status), lang)}
                </div>
              </div>

              <div className="textWithSvg" style={{ marginLeft: "10px" }}>
                <div className="svg">
                  <HistorySmallSvg style={{ marginLeft: "3px" }} />
                </div>
                <div className="text">
                  <Tooltip
                    title={
                      i18n(lang)?.reported +
                      ": " +
                      moment(notificationData?.created).format("DD.MM.YY") +
                      ", " +
                      moment(notificationData?.created).format("hh:mm") +
                      i18n(lang).clock +
                      (notificationData?.hasauthor
                        ? notificationData?.hasauthor[0]?.user?.givenname
                        : "") +
                      " " +
                      (notificationData?.hasauthor
                        ? notificationData?.hasauthor[0]?.user?.surname
                        : "")
                    }
                  >
                    <div>
                      {i18n(lang)?.reported + ": "}

                      <span
                        style={{
                          borderBottomStyle: "dotted",
                          borderBottomWidth: "1px",
                        }}
                      >
                        {moment(notificationData?.created).format("DD.MM.YY")}
                      </span>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </Grid>

          <Grid
            container
            spacing={3}
            direction="row"
            
          >
            <Grid item xs={12}>
              <AppBar position="static">
                <Tabs
                  className="ND_tabs"
                  value={activeTab}
                 
                  variant="scrollable"
                >
                  <Tab
                    key={0}
                    label={i18n(lang)?.tab_overview}
                    sx={{
                      color: "inherit",
                      paddingLeft: "25px",
                      width: "150px",
                    }}
                  />
                </Tabs>
              </AppBar>

              <TabPanel value={activeTab} index={0}>
                <OverviewTab notificationData={notificationData} />
              </TabPanel>
            </Grid>
          </Grid>
        </Paper>

        <>
          <Dialog
            sx={{ backdropFilter: "blur(4px)" }}
            maxWidth={"xs"}
            fullWidth
            TransitionComponent={Zoom}
            open={isShare}
            onClose={handleShareClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="share-notification-dialog"
          >
            <DialogTitle id="alert-dialog-title">
              {i18n(lang)?.share_notification}
            </DialogTitle>
            <DialogContent id="alert-dialog-description">
              {i18n(lang)?.write_mail}
            </DialogContent>
            <DialogActions
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0px 22px 22px 22px",
              }}
            >
              <TextField
                variant="outlined"
                label={i18n(lang)?.eemail}
                type="email"
                sx={{ width: "100% " }}
                onChange={handleShareInputChange}
                value={email}
                error={
                  email.length === 0 ||
                  !email.includes("@") ||
                  !email.includes(".")
                }
                required
              />
              <Button
                className="bxShadow"
                sx={{
                  width: "100% ",
                  marginTop: "10px",
                  marginLeft: "0px !important",
                }}
                variant="outlined"
                startIcon={<Send />}
                disabled={
                  email.length === 0 ||
                  !email.includes("@") ||
                  !email.includes(".")
                }
                onClick={handleShareSubmit}
              >
                {i18n(lang)?.share_email_btn}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      </section>
    </>
  );
}

export default NotificationDetailPage;
